export const domain = 'FindCustomer';

// action types
export const SET_MODAL_MESSAGE = `${domain}/SET_MODAL_MESSAGE`;
export const OPEN_MODAL = `${domain}/OPEN_MODAL`;
export const CLOSE_MODAL = `${domain}/CLOSE_MODAL`;

/* These codes are in INCL.DEFS/AR.711.ARGS for AK46.RESULT from 9.8 patch number 848284
1 - No existing customer found. A new credit app can be submitted (and a new customer will be created when the app is submitted)
2 - Customer found and doesn't have a recent app. A new credit app can be submitted.
5 - Multiple customers found and no social match. A new credit app can be submitted (and a new customer will be created when the app is submitted)
*/
export const ACCEPTABLE_CODES = ['1', '2', '5'];
